// NOTE: When a new language is added here, fetch-translations script should be modified as well

/**
 * Supported locales/languages in the application
 */
export enum LocaleEnum {
  EN = 'en',
  DE = 'de',
  FR = 'fr',
  IT = 'it',
  ES = 'es',
}

/**
 * Wraps a remote translations module with local overrides so we can ship new
 * keys ahead of the S3 source-of-truth being updated. Locally declared keys
 * win over the auto-fetched ones, allowing temporary copy edits without
 * risking the next `pnpm fetch-translations` run wiping them out.
 */
const withLocalOverrides = async <T extends Record<string, unknown>>(
  remote: Promise<{ default: T }>,
  overrides: Promise<{ default: Record<string, string> }>,
) => {
  const [{ default: remoteTranslations }, { default: localTranslations }] = await Promise.all([
    remote,
    overrides,
  ]);
  return { default: { ...remoteTranslations, ...localTranslations } as T };
};

/**
 * Translation files for supported languages
 */
export const translationFiles = {
  en: () => withLocalOverrides(import('./.translations/en'), import('./local-overrides/en')),
  de: () => withLocalOverrides(import('./.translations/de'), import('./local-overrides/de')),
  fr: () => withLocalOverrides(import('./.translations/fr'), import('./local-overrides/fr')),
  it: () => withLocalOverrides(import('./.translations/it'), import('./local-overrides/it')),
  es: () => withLocalOverrides(import('./.translations/es'), import('./local-overrides/es')),
};
